import axios from '@/lib/AxApi';

const fail = (cb) => (e) =>
{
    cb({ error: true, notice: (e && e.message) ? e.message : 'Network error' });
};

export default
{
    hasAccess(params, cb)
    {
        axios.get('/Modules/hasNsPanelAccess', { params })
            .then((response) =>
            {
                cb(response.data);
            })
            .catch(fail(cb));
    },
    getState(params, cb)
    {
        axios.get('/Modules/getNsPanelState', { params })
            .then((response) =>
            {
                cb(response.data);
            })
            .catch(fail(cb));
    },
    setAcPower(params, cb)
    {
        axios.post('/Modules/setAcPower', params)
            .then((response) =>
            {
                cb(response.data);
            })
            .catch(fail(cb));
    },
    setAcMode(params, cb)
    {
        axios.post('/Modules/setAcMode', params)
            .then((response) =>
            {
                cb(response.data);
            })
            .catch(fail(cb));
    },
    setRecoupPower(params, cb)
    {
        axios.post('/Modules/setRecoupPower', params)
            .then((response) =>
            {
                cb(response.data);
            })
            .catch(fail(cb));
    },
    setRecoupSeason(params, cb)
    {
        axios.post('/Modules/setRecoupSeason', params)
            .then((response) =>
            {
                cb(response.data);
            })
            .catch(fail(cb));
    },
    setRecoupMode(params, cb)
    {
        axios.post('/Modules/setRecoupMode', params)
            .then((response) =>
            {
                cb(response.data);
            })
            .catch(fail(cb));
    },
    setRecoupFans(params, cb)
    {
        axios.post('/Modules/setRecoupFans', params)
            .then((response) =>
            {
                cb(response.data);
            })
            .catch(fail(cb));
    },
    setRecoupRoomTemp(params, cb)
    {
        axios.post('/Modules/setRecoupRoomTemp', params)
            .then((response) =>
            {
                cb(response.data);
            })
            .catch(fail(cb));
    },
    setRoomAcTemp(params, cb)
    {
        axios.post('/Modules/setRoomAcTemp', params)
            .then((response) =>
            {
                cb(response.data);
            })
            .catch(fail(cb));
    },
    setRoomBoost(params, cb)
    {
        axios.post('/Modules/setRoomBoost', params)
            .then((response) =>
            {
                cb(response.data);
            })
            .catch(fail(cb));
    },
    setRoomThermostat(params, cb)
    {
        axios.post('/Modules/setRoomThermostat', params)
            .then((response) =>
            {
                cb(response.data);
            })
            .catch(fail(cb));
    },
    // lights and shutters go through the existing Modules methods
    activateDevice(params, cb)
    {
        axios.post('/Modules/activateDevice', params)
            .then((response) =>
            {
                cb(response.data);
            })
            .catch(fail(cb));
    },
    activateSecDevice(params, cb)
    {
        axios.post('/Modules/activateSecDevice', params)
            .then((response) =>
            {
                cb(response.data);
            })
            .catch(fail(cb));
    },
    stopDevice(params, cb)
    {
        axios.post('/Modules/stopDevice', params)
            .then((response) =>
            {
                cb(response.data);
            })
            .catch(fail(cb));
    },
    setDimmer(params, cb)
    {
        axios.post('/Modules/setDimmer', params)
            .then((response) =>
            {
                cb(response.data);
            })
            .catch(fail(cb));
    },
};
